import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

import {
  formatSettlementPaymentCurrency,
  formatSettlementPaymentDate,
} from "./helpers/functions";

function DetailField({ label, value }) {
  return (
    <div className="min-w-0">
      <Typography className="text-xs font-semibold uppercase" sx={SETTLEMENT_STYLES.detailLabelText}>
        {label}
      </Typography>
      <Typography
        className="break-words whitespace-pre-wrap text-sm"
        sx={SETTLEMENT_STYLES.detailValueText}
      >
        {value ?? "N/A"}
      </Typography>
    </div>
  );
}

export default function SettlementPaymentsRowDetails({ payment }) {
  return (
    <div
      className="flex flex-col gap-4 rounded-[8px] p-4"
      style={{ backgroundColor: HNSColors.tertiary[900] }}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <DetailField
          label="Intended Recipient"
          value={payment.intendedRecipient?.name ?? payment.intended_recipient?.name ?? "N/A"}
        />
        <DetailField
          label="Payment Identification"
          value={payment.checkNumber ?? payment.check_number ?? "N/A"}
        />
        <DetailField label="Payable Amount" value={payment.batchNumber ?? payment.batch_number ?? "N/A"} />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <DetailField label="Payment Amount" value={formatSettlementPaymentCurrency(payment.amount)} />
        <DetailField
          label="Total Amount"
          value={formatSettlementPaymentCurrency(payment.totalAmount ?? payment.total_amount)}
        />
        <DetailField label="Receivable Amount" value={formatSettlementPaymentCurrency(payment.receivable)} />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <DetailField
          label="Payment Date"
          value={formatSettlementPaymentDate(payment.checkDate ?? payment.check_date)}
        />
        <DetailField
          label="Deposit Date"
          value={formatSettlementPaymentDate(payment.depositDate ?? payment.deposit_date)}
        />
        <DetailField
          label="CNB Deposit Date"
          value={formatSettlementPaymentDate(payment.cnbDepositDate ?? payment.cnb_deposit_date)}
        />
      </div>

      <DetailField label="Notes" value={payment.notes || "N/A"} />
    </div>
  );
}
